import styled from 'styled-components';
import { TypographyStyles, media, spacing } from '@storefront/lib-global';
import { FlexibleTextPartial } from '@storefront/lib-global/partials';

export const SizeAndWidthSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;

  &:empty {
    display: none;
  }

  @media ${media.greaterThan('lg')} {
    margin-top: 38px;
  }
`;

export const SizeSelectorContainer = styled.fieldset`
  border: none;
  display: flex;
  flex-direction: column;
  gap: ${spacing.XXS};
  margin: 0;
  padding: 0;
`;

export const SizeTextWrapper = styled.legend`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const SizeHeadText = styled.span`
  ${TypographyStyles.Headings.H5}
  font-size: 14px;
  line-height: 24px;
  margin: 0;

  @media ${media.greaterThan('lg')} {
    font-size: 16px;
    line-height: 28px;
  }
`;

export const SizeHeadDescription = styled(FlexibleTextPartial)`
  margin: 0;
  text-decoration: underline;
  text-transform: capitalize;

  @media ${media.greaterThan('lg')} {
    line-height: 22px;
  }
`;

export const SizeGuideButton = styled.button<{ $hasSizeGuideTitle: boolean }>`
  background: none;
  border: none;
  display: ${({ $hasSizeGuideTitle }) => ($hasSizeGuideTitle ? 'inline-block' : 'none')};
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
